import React from 'react';
import { Button, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useModel } from '@umijs/max';

const ThemeToggle: React.FC = () => {
  const { initialState, setInitialState } = useModel('@@initialState');
  
  const currentTheme = initialState?.settings?.navTheme || 'light';
  const isDark = currentTheme === 'realDark';

  const handleThemeChange = () => {
    const newTheme = isDark ? 'light' : 'realDark';
    setInitialState((prev: any) => ({
      ...prev,
      settings: {
        ...prev.settings,
        navTheme: newTheme,
      },
    }));
  };

  return (
    <Tooltip title={isDark ? 'Switch to Light Theme' : 'Switch to Dark Theme'}>
      <Button
        type="text"
        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
        onClick={handleThemeChange}
        style={{ fontSize: 'var(--font-l)' }}
        size="small"
      />
    </Tooltip>
  );
};

export default ThemeToggle; 